import { render, staticRenderFns } from "./FollowUpSettingAdd.vue?vue&type=template&id=3bb5a320&"
import script from "./FollowUpSettingAdd.vue?vue&type=script&lang=js&"
export * from "./FollowUpSettingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports